import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import jobs from "../../apiConfigs/jobs";
import { ReactComponent as Delete } from "../../assets/delete.svg";
import { ReactComponent as Edit } from "../../assets/edit.svg";
import DeleteModal from "../../designComponents/DeleteModal";
import LabelInputField from "../../designComponents/LabelInputField/LabelInputField";
import MediaUploader from "../../designComponents/MediaUpload/MediaUpload";
import Modal from "../../designComponents/Modal";
import requestAPI from "../../utils/requestAPI";
import { getIconsUrl } from "../../utils/resizeImages";
import { uploadFilesToS3OnlyKeys } from "../../utils/s3Upload";
import {
  AcceptButton,
  ButtonsSection,
  Card,
  LabelText,
  SectionTitle,
  TitleSection,
} from "../Properties/Details/styles";

function TradesCategories() {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  const [tradeCategories, setTradeCategories] = useState<
    { title: string; _id: string; images: string[] }[]
  >([]);
  const [openDeleteModal, setOpenDeleteModal] = useState<string | null>(null);
  const [title, setTitle] = useState<string>("");
  const [initialValues, setInitialValues] = useState<{
    title: string;
    file?: File | null;
    images: string[];
  }>({ title: "", images: [] });
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = useState<string | null>(null);

  const getTradesCategories = async () => {
    const response = await requestAPI(jobs.getTradeCategories());
    setTradeCategories(response.data);
  };
  useEffect(() => {
    getTradesCategories();
  }, []);

  const handleDeleteTradeCategories = async (id: string) => {
    try {
      await requestAPI(jobs.deleteTradeCategories(id));
      toast.success("Successfully Deleted");
      setOpenDeleteModal(null);
      getTradesCategories();
    } catch (error: any) {
      toast.error("Error " + error.message);
    }
  };
  const handleAdd = async () => {
    let providedUrl;
    try {
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "assets",
          fileUri: [uploadedFile],
          assetsCategory: "Trade Categories",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(
            jobs.postTradeCategories({ title: title, images: [providedUrl] })
          );
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(
          jobs.postTradeCategories({ title: title, images: [providedUrl] })
        );
      }
      setOpenModal(false);
      setTitle("");
      setUploadedFile(null);
      toast.success("Successfylly Added Trade Category");
      getTradesCategories();
    } catch (error: any) {
      toast.error("Error:" + error.message);
    }
  };
  const handleEdit = async (id: string) => {
    let providedUrl;
    try {
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "assets",
          fileUri: [uploadedFile],
          assetsCategory: "Trade Categories",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(
            jobs.updateTradeCategories(id, {
              images: [providedUrl],
              title: title || initialValues?.title,
            })
          );
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(
          jobs.updateTradeCategories(id, { images: [providedUrl], title })
        );
      } else if (!uploadedFile) {
        await requestAPI(
          jobs.updateTradeCategories(id, {
            images: initialValues?.images ? initialValues?.images : [],
            title,
          })
        );
      }
      setOpenEditModal(null);
      setInitialValues({ title: "", images: [] });
      getTradesCategories();
      toast.success("Successfylly Updated Rule Category");
    } catch (error: any) {
      toast.error("Error:" + error.message);
    }
  };
  return (
    <div>
      <Card style={{ margin: 0 }}>
        <TitleSection>
          <ButtonsSection>
            <SectionTitle>Trades Category</SectionTitle>
            <AcceptButton
              onClick={() => {
                setOpenModal(true);
              }}
            >
              Add Category
            </AcceptButton>
          </ButtonsSection>
        </TitleSection>
        {tradeCategories.map((item, index) => {
          return (
            <ButtonsSection key={index}>
              <div
                style={{
                  display: "flex",
                  gap: 40,
                  alignItems: "center",
                }}
              >
                <img
                  src={getIconsUrl(item.images?.[0])}
                  width={40}
                  height={40}
                  alt={item.title}
                ></img>
                <LabelText>{item.title}</LabelText>
              </div>
              <div style={{ display: "flex", gap: 20, cursor: "pointer" }}>
                <div
                  onClick={() => {
                    setOpenDeleteModal(item._id);
                  }}
                >
                  <Delete fill="#7E7E7E"></Delete>
                </div>
                <div
                  onClick={() => {
                    setOpenEditModal(item._id);
                    setInitialValues({
                      title: item.title,
                      images: item.images,
                    });
                  }}
                >
                  <Edit fill="#7E7E7E" />
                </div>
              </div>

              {openDeleteModal === item._id && (
                <DeleteModal
                  loading={false}
                  onClose={() => {
                    setOpenDeleteModal(null);
                  }}
                  itemName="Category"
                  title="Are you sure you want to delete this Category"
                  isOpen={true}
                  onDelete={() => {
                    handleDeleteTradeCategories(item._id);
                  }}
                ></DeleteModal>
              )}

              {openEditModal === item._id && (
                <Modal
                  halfWidth
                  isOpen={true}
                  title="Edit Trades Category"
                  onClose={() => {
                    setOpenEditModal(null);
                  }}
                >
                  <LabelInputField
                    label="Title Name"
                    value={initialValues.title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                      setInitialValues({
                        title: e.target.value,
                        images: initialValues.images,
                      });
                    }}
                    name="title"
                    style={{
                      label: {
                        fontSize: "14px",
                        fontWeight: "500px",
                        color: "#555A77",
                      },
                      input: {
                        height: 50,
                        border: "1px solid #F1EFFB",
                        padding: 8,
                        background: "#F1EFFB",
                        borderRadius: 6,
                        width: "100%",
                      },
                      container: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        paddingTop: 14,
                      },
                    }}
                  ></LabelInputField>
                  <MediaUploader
                    label="Icon"
                    image={
                      initialValues.images &&
                      typeof initialValues.images === "string"
                        ? [initialValues.images]
                        : []
                    }
                    onChange={(e) => {
                      const file = e.target.files?.[0] || null;
                      setUploadedFile(file);
                      setInitialValues({
                        title: initialValues.title,
                        file: file,
                        images: initialValues.images,
                      });
                    }}
                    style={{
                      container: { paddingTop: 10, gap: 6, marginBottom: 10 },
                      label: { paddingBottom: 10, color: "#555A77" },
                      dropzone: { background: "#F1EFFB" },
                    }}
                  ></MediaUploader>
                  <AcceptButton
                    onClick={() => {
                      handleEdit(item._id);
                    }}
                  >
                    Confirm
                  </AcceptButton>
                </Modal>
              )}
            </ButtonsSection>
          );
        })}
        <Modal
          halfWidth
          isOpen={openModal}
          title="Add Trades Category"
          onClose={() => {
            setOpenModal(false);
          }}
        >
          <LabelInputField
            label="Title Name"
            onChange={(e) => {
              setTitle(e.target.value);
            }}
            name="title"
            style={{
              label: {
                fontSize: "14px",
                fontWeight: "500px",
                color: "#555A77",
              },
              input: {
                height: 50,
                border: "1px solid #F1EFFB",
                padding: 8,
                background: "#F1EFFB",
                borderRadius: 6,
                width: "100%",
              },
              container: {
                display: "flex",
                flexDirection: "column",
                gap: 6,
                paddingTop: 14,
              },
            }}
          ></LabelInputField>
          <MediaUploader
            label="Icon"
            onChange={(e) => {
              const file = e.target.files?.[0] || null;
              setUploadedFile(file);
            }}
            style={{
              container: { paddingTop: 10, gap: 6, marginBottom: 10 },
              label: { paddingBottom: 10, color: "#555A77" },
              dropzone: { background: "#F1EFFB" },
            }}
          ></MediaUploader>
          <AcceptButton
            onClick={() => {
              handleAdd();
            }}
          >
            {" "}
            Add
          </AcceptButton>
        </Modal>
      </Card>
    </div>
  );
}

export default TradesCategories;
